/**
 * 出力ファイル一覧
 */
import Vue from 'vue'
import * as httpConst from '../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/output_files`

const output_file = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    index({ commit }, { conditions }) {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: conditions }).then(data => {
          resolve(data.content)
        })
      })
    },
    show({commit}, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    delete({commit}, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.delete(api_path).then(data => {
          resolve(data.content)
        })
      })
    }
  },
  mutations: {
  },
}

export default output_file
